/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Captured at the point the Availity payer dropdown option couldn't be selected. Present only for PAYER_NOT_FOUND.
 * @export
 * @interface PalAuthSubmissionMetadataErrorDetailsPayerNotFound
 */
export interface PalAuthSubmissionMetadataErrorDetailsPayerNotFound {
    /**
     *
     * @type {string}
     * @memberof PalAuthSubmissionMetadataErrorDetailsPayerNotFound
     */
    payer_value: string;
    /**
     *
     * @type {string}
     * @memberof PalAuthSubmissionMetadataErrorDetailsPayerNotFound
     */
    facility_name: string;
    /**
     *
     * @type {string}
     * @memberof PalAuthSubmissionMetadataErrorDetailsPayerNotFound
     */
    region_name: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionMetadataErrorDetailsPayerNotFound interface.
 */
export function instanceOfPalAuthSubmissionMetadataErrorDetailsPayerNotFound(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "payer_value" in value;
    isInstance = isInstance && "facility_name" in value;
    isInstance = isInstance && "region_name" in value;

    return isInstance;
}

export function PalAuthSubmissionMetadataErrorDetailsPayerNotFoundFromJSON(json: any): PalAuthSubmissionMetadataErrorDetailsPayerNotFound {
    return PalAuthSubmissionMetadataErrorDetailsPayerNotFoundFromJSONTyped(json, false);
}

export function PalAuthSubmissionMetadataErrorDetailsPayerNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionMetadataErrorDetailsPayerNotFound {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'payer_value': json['payer_value'],
        'facility_name': json['facility_name'],
        'region_name': json['region_name'],
    };
}

export function PalAuthSubmissionMetadataErrorDetailsPayerNotFoundToJSON(value?: PalAuthSubmissionMetadataErrorDetailsPayerNotFound | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'payer_value': value.payer_value,
        'facility_name': value.facility_name,
        'region_name': value.region_name,
    };
}

